import { render, staticRenderFns } from "./WhatIfResearchOutputList.vue?vue&type=template&id=2138d433&scoped=true&"
import script from "./WhatIfResearchOutputList.vue?vue&type=script&lang=js&"
export * from "./WhatIfResearchOutputList.vue?vue&type=script&lang=js&"
import style0 from "./WhatIfResearchOutputList.vue?vue&type=style&index=0&id=2138d433&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2138d433",
  null
  
)

export default component.exports